module.exports = __webpack_public_path__ + "assets/endTrip.43e2c21b.svg";